import { clearLoginState } from '@/business/login'
import { subscribeLoginExpiredEvent, triggerGotoLoginExpiredEvent } from '@/business/login/help'
import React from 'react'

const useSubScribeLoginExpire = () => {
  React.useEffect(() => {
    subscribeLoginExpiredEvent(() => {
      clearLoginState()
    })
    const win = window as Window & { tx?: typeof triggerGotoLoginExpiredEvent }
    win.tx = triggerGotoLoginExpiredEvent
  }, [])
}

export default useSubScribeLoginExpire
